export default {"src":"/_next/static/media/alison-ai-logo.006ea1d2.svg","height":26,"width":120,"blurWidth":0,"blurHeight":0};